import { type WrappedInsightTopWorkplacesAttributes } from "@clipboard-health/contract-worker-app-bff";
import { Image, Text } from "@clipboard-health/ui-components";
import pinImagePath from "@src/appV2/lib/assets/images/cbh-wrapped/pin.png";

import { InsightContentWrapper } from "../InsightContentWrapper";
import { TopWorkplaceRow } from "./TopWorkplaceRow";

interface TopWorkplacesContentProps {
  attributes: WrappedInsightTopWorkplacesAttributes;
}

export function TopWorkplacesContent(props: TopWorkplacesContentProps) {
  const { attributes } = props;

  return (
    <InsightContentWrapper sx={{ gap: 7 }}>
      <Text
        variant="h4"
        sx={{
          marginTop: 5,
        }}
      >
        Your top {attributes.workplaces.length} workplaces:
      </Text>

      {attributes.workplaces.map((workplace, index) => (
        <TopWorkplaceRow key={workplace} workplace={workplace} index={index} />
      ))}

      <Image src={pinImagePath} alt="Pin" sx={{ position: "absolute", bottom: 0, right: 0 }} />
    </InsightContentWrapper>
  );
}
